export default __webpack_public_path__ + "static/media/cryllex.aa75aa6f.svg";